<div class="company-joblist-cont">

  <app-joblist [companyId]="companyId"></app-joblist>

  <!-- Job Alert -->
  <div class="job-alert">
    <div class="alert-card">
      <p class="alert-title">📨 Email me for jobs</p>
      <p class="alert-desc">Ut esse eiusmod aute. Sit enim labore dolore. Aute ea fugiat commodo ea foes.</p>
      <input class="alert-input" type="email" placeholder="name@mail.com" [(ngModel)]="alertEmail" />
      <p class="alert-error" *ngIf="emailError">{{ emailError }}</p>
      <p class="alert-success" *ngIf="emailSuccess">{{ emailSuccess }}</p>
      <button class="alert-btn-primary" (click)="subscribeEmail()">Subscribe</button>
    </div>
  </div>

</div>